import { useCallback } from "react";
import { useNavigate } from "react-router";

import {
  AddressInput,
  useFindPolicyForClaimLazyQuery,
} from "@api/operations.generated";
import { useAppDispatch } from "@redux/hooks";
import {
  setDateOfLoss,
  setPolicyLocator,
  setPropertyAddress,
} from "@redux/slices";
import { StepPath } from "@routing/paths";

import { PolicyDetailsForm as PolicyDetailsFormType } from "./form";

export function useFindPolicyFormClaimByAddress() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [findPolicyForClaim, { loading }] = useFindPolicyForClaimLazyQuery();

  const submit = useCallback(
    async (formValues: PolicyDetailsFormType) => {
      const {
        address: {
          value: {
            city,
            country,
            state,
            postCode,
            lotUnit: addressLotUnit,
            mainAddressLine,
          },
        },
      } = formValues;

      const lotUnit = formValues.lotUnit ?? addressLotUnit ?? null;
      const addressInput: AddressInput = {
        city,
        countryCode: country,
        lotUnit,
        stateCode: state,
        streetAddress: mainAddressLine,
        zipCode: postCode,
      };

      const { data } = await findPolicyForClaim({
        variables: {
          input: {
            propertyAddress: addressInput,
          },
        },
      });

      dispatch(
        setPropertyAddress({
          ...formValues.address,
          value: {
            ...formValues.address.value,
            lotUnit,
          },
        })
      );
      dispatch(setDateOfLoss(formValues.dateOfLoss));
      dispatch(setPolicyLocator(null));
      if (data?.findPolicyForClaim) {
        navigate(`/${StepPath.LOSS_LOCATION_DETAILS}`);
      } else {
        navigate(`/${StepPath.MISSING_POLICY_DETAILS}`);
      }
    },
    [findPolicyForClaim, dispatch, navigate]
  );

  return {
    findPolicyForClaim: submit,
    loading,
  };
}
